<!-- SINGLE ITEM -->
<div
  class="nav-item"
  [class.selected]="isSelected"
  [class.hasChildren]="visibleChildren.length"
  #panelRef>
  <div [ngSwitch]="item.type">
    <button
      type="button"
      *ngSwitchCase="'button'"
      class="__item"
      (click)="item.click ? item.click() : null">
      <img class="__icon" *ngIf="item.icon" [src]="item.icon" />
      <mat-icon class="__icon __material" *ngIf="item.materialIcon"
        >{{ item.materialIcon }}
      </mat-icon>
      <span class="__text">{{ item.text }}</span>
    </button>
    <a
      *ngSwitchCase="'url'"
      class="__item"
      [attr.href]="item.url"
      [title]="!isSidebarExpanded ? item.text : ''">
      <img class="__icon" *ngIf="item.icon" [src]="item.icon" />
      <mat-icon class="__icon __material" *ngIf="item.materialIcon"
        >{{ item.materialIcon }}
      </mat-icon>
      <span class="__text">{{ item.text }}</span>
    </a>
    <a
      *ngSwitchCase="'route'"
      class="__item"
      [routerLink]="item.route"
      [queryParams]="item.queryParams"
      [title]="!isSidebarExpanded ? item.text : ''">
      <img class="__icon" *ngIf="item.icon" [src]="item.icon" />
      <mat-icon class="__icon __material" *ngIf="item.materialIcon"
        >{{ item.materialIcon }}
      </mat-icon>
      <span class="__text">{{ item.text }}</span>
    </a>
    <div
      class="__item"
      *ngSwitchDefault
      [title]="!isSidebarExpanded ? item.text : ''"
      (click)="openOverlay()">
      <img class="__icon" *ngIf="item.icon" [src]="item.icon" />
      <mat-icon class="__icon __material" *ngIf="item.materialIcon"
        >{{ item.materialIcon }}
      </mat-icon>
      <span class="__text">{{ item.text }}</span>
    </div>
  </div>
  <mat-icon class="__carret" (click)="openOverlay()">
    {{ isSubmenuOpened ? 'expand_less' : 'expand_more' }}
  </mat-icon>
</div>
<!-- CHILDREN -->
<div *ngIf="visibleChildren.length" class="nav-item-children">
  <!-- INLINE CHILDREN -->
  <oiq-layout-nav-item
    *ngFor="let child of visibleChildren; trackBy: trackByItem"
    [item]="child"
    [path]="path"
    [siblings]="visibleChildren"
    [isSidebarExpanded]="true"></oiq-layout-nav-item>
</div>

<ng-template #childrenRef>
  <div
    class="oiq-layout-nav oiq-layout-nav-portal"
    (mouseenter)="openOverlay()"
    (mouseleave)="closeOverlay()">
    <label>{{ item.text }}</label>
    <oiq-layout-nav-item
      *ngFor="let child of visibleChildren; trackBy: trackByItem"
      [item]="child"
      [path]="path"
      [siblings]="visibleChildren"
      [isSidebarExpanded]="true"></oiq-layout-nav-item>
  </div>
</ng-template>
